export default {
  type: "Feature",
  properties: {
    gid: 282270,
    name: "Говийн бүс",
    location: [44.57212352785404, 104.89266709270808],
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [
      [
        [
          [107.977556, 42.413528],
          [107.966457, 42.413384],
          [107.960417, 42.413306],
          [107.938486970999975, 42.405674518000012],
          [107.930083, 42.40275],
          [107.898194, 42.404528],
          [107.833556, 42.408111],
          [107.788389, 42.410556],
          [107.727389, 42.413833],
          [107.726555, 42.41382],
          [107.682583, 42.413111],
          [107.634361, 42.412306],
          [107.568389, 42.411195],
          [107.559572, 42.416532],
          [107.549667, 42.422528],
          [107.531898590000026, 42.433273045000021],
          [107.494622764999974, 42.45581476000001],
          [107.4945, 42.455889],
          [107.494433126, 42.45589286400002],
          [107.459889, 42.457889],
          [107.426103, 42.44798],
          [107.407889, 42.442639],
          [107.358222, 42.428028],
          [107.355566, 42.427243],
          [107.350506038999981, 42.42574881500002],
          [107.287861, 42.40725],
          [107.274776, 42.381577],
          [107.265194, 42.362778],
          [107.265083, 42.362361],
          [107.23669, 42.35623],
          [107.203333, 42.349028],
          [107.135972, 42.334445],
          [107.13545105999998, 42.334334968],
          [107.129698997999981, 42.333120031000021],
          [107.043778, 42.314972],
          [107.015632, 42.312361],
          [106.99939156, 42.310853813],
          [106.983306, 42.309361],
          [106.918278, 42.303333],
          [106.854528, 42.297056],
          [106.791918, 42.290853],
          [106.783028, 42.289972],
          [106.750894, 42.280692],
          [106.734361, 42.275917],
          [106.690161511999975, 42.263110655999981],
          [106.684889, 42.261583],
          [106.684718681999982, 42.261533507000024],
          [106.683028508, 42.261042358999987],
          [106.652856558999986, 42.252274682],
          [106.644787093, 42.249929773000019],
          [106.642964, 42.2494],
          [106.637539877999984, 42.247823636000021],
          [106.606222, 42.238722],
          [106.594660705000024, 42.234816756999976],
          [106.581218, 42.230276],
          [106.560583, 42.223306],
          [106.516583, 42.208389],
          [106.446528, 42.184611],
          [106.366333, 42.157278],
          [106.314917, 42.138778],
          [106.242806, 42.112778],
          [106.161139, 42.08325],
          [106.076, 42.052333],
          [106.027, 42.035806],
          [105.954722, 42.011361],
          [105.954371685000012, 42.011254199],
          [105.919917, 42.00075],
          [105.885611, 41.990278],
          [105.833806, 41.974361],
          [105.794778, 41.962389],
          [105.716139, 41.938194],
          [105.661, 41.915806],
          [105.642806, 41.908333],
          [105.625670368999977, 41.901571409999974],
          [105.625497, 41.901503],
          [105.583611, 41.884972],
          [105.547959, 41.86628],
          [105.547145320000027, 41.865853372],
          [105.521889, 41.852611],
          [105.512864725999975, 41.848577121],
          [105.512379, 41.84836],
          [105.483917, 41.835639],
          [105.421639, 41.809917],
          [105.38275, 41.794806],
          [105.371533, 41.786115],
          [105.367250855, 41.78279756500001],
          [105.361417, 41.778278],
          [105.34275, 41.771139],
          [105.33508, 41.768209],
          [105.328278, 41.765611],
          [105.322728036, 41.763041116000011],
          [105.316331, 41.760079],
          [105.289889, 41.747833],
          [105.261644, 41.748108],
          [105.229806, 41.748417],
          [105.229403422000019, 41.748116042999982],
          [105.229394, 41.748109],
          [105.225641, 41.745308],
          [105.220503608, 41.741472817999977],
          [105.20975, 41.733445],
          [105.172496916, 41.705649262],
          [105.170935969000027, 41.704484589],
          [105.160530531, 41.696720753000022],
          [105.157778, 41.694667],
          [105.153014687999985, 41.691102189],
          [105.093528, 41.646583],
          [105.083556, 41.639153],
          [105.048417, 41.612972],
          [105.020584, 41.592195],
          [105.006695, 41.581833],
          [105.003611, 41.584323],
          [104.964139, 41.616195],
          [104.917084, 41.654195],
          [104.872972, 41.652528],
          [104.824806, 41.650695],
          [104.770695, 41.648611],
          [104.711611, 41.646278],
          [104.681584, 41.645111],
          [104.602139, 41.65275],
          [104.590908, 41.65383],
          [104.540334, 41.658695],
          [104.518791282999985, 41.660731898],
          [104.517722, 41.660833],
          [104.519667, 41.715806],
          [104.521806, 41.776778],
          [104.523472, 41.821528],
          [104.524696, 41.858689],
          [104.524741342000027, 41.860066317000019],
          [104.525222, 41.874667],
          [104.495743876, 41.870100093000019],
          [104.49564, 41.870084],
          [104.493667, 41.869778],
          [104.47756, 41.867276],
          [104.476746403, 41.867149649999988],
          [104.420695, 41.858445],
          [104.379692, 41.852037],
          [104.378998893000016, 41.851928666999981],
          [104.361861, 41.84925],
          [104.303157842000019, 41.840046321999978],
          [104.302333, 41.839917],
          [104.280624971, 41.836499241000013],
          [104.280471, 41.836475],
          [104.233694, 41.829111],
          [104.18, 41.820639],
          [104.118111, 41.810833],
          [104.073806, 41.803778],
          [104.019722, 41.802889],
          [103.976111, 41.802139],
          [103.95575, 41.801778],
          [103.920583, 41.801139],
          [103.883440004000022, 41.800483626000016],
          [103.88338644800001, 41.800483058],
          [103.876444, 41.800361],
          [103.854889, 41.799945],
          [103.845455922999975, 41.802060999],
          [103.845446938, 41.802062663000015],
          [103.807972, 41.810472],
          [103.796778, 41.812972],
          [103.741667, 41.825167],
          [103.706556, 41.830639],
          [103.672333, 41.835972],
          [103.614349376, 41.844930792000014],
          [103.614238, 41.844948],
          [103.612639, 41.845195],
          [103.59979, 41.84755],
          [103.594394421, 41.848539035999977],
          [103.571722, 41.852695],
          [103.520639, 41.862056],
          [103.450878, 41.874838],
          [103.447417, 41.875472],
          [103.442899322000017, 41.876297720000025],
          [103.413222, 41.881722],
          [103.367801, 41.898519],
          [103.367210677, 41.898737293000011],
          [103.357111, 41.902472],
          [103.316444, 41.9175],
          [103.283676947, 41.929524859000026],
          [103.283652263000022, 41.929534077000028],
          [103.245972, 41.943361],
          [103.187056, 41.964972],
          [103.156824, 41.975968],
          [103.077833, 42.004944],
          [103.047333, 42.016056],
          [102.993106574000024, 42.035814577],
          [102.992444, 42.036056],
          [102.925, 42.063639],
          [102.891889, 42.077167],
          [102.832889, 42.101167],
          [102.803583, 42.113111],
          [102.779311, 42.122983],
          [102.768, 42.127583],
          [102.750777649999975, 42.134557982999979],
          [102.709513, 42.15127],
          [102.70950979700001, 42.151271295000015],
          [102.708944, 42.1515],
          [102.641861, 42.151972],
          [102.581611, 42.15725],
          [102.541278, 42.160778],
          [102.504528, 42.154583],
          [102.446028, 42.144667],
          [102.373972, 42.160472],
          [102.298278, 42.177028],
          [102.24, 42.189722],
          [102.17225, 42.204444],
          [102.168664786000022, 42.205220042],
          [102.168512756999974, 42.205253958000014],
          [102.102194, 42.219611],
          [102.076611, 42.225139],
          [102.049389, 42.252778],
          [102.010111, 42.292556],
          [101.988556, 42.314361],
          [101.956482, 42.34678],
          [101.94725, 42.356111],
          [101.911333, 42.392361],
          [101.883417, 42.4205],
          [101.836555, 42.467667],
          [101.800452582999981, 42.503935405],
          [101.80045, 42.503938],
          [101.800278, 42.504111],
          [101.750253, 42.508853],
          [101.74985386100002, 42.508890839],
          [101.719694, 42.51175],
          [101.646944, 42.518611],
          [101.575056, 42.525333],
          [101.567444, 42.526028],
          [101.494556, 42.541111],
          [101.423583, 42.55575],
          [101.348528, 42.571139],
          [101.317167, 42.577556],
          [101.277444, 42.585695],
          [101.23682, 42.593981],
          [101.236224994, 42.594102352999982],
          [101.211667, 42.599111],
          [101.144111, 42.612833],
          [101.074444, 42.626972],
          [101.015778, 42.638806],
          [100.955, 42.651083],
          [100.9265, 42.656806],
          [100.84825, 42.672528],
          [100.782722, 42.6745],
          [100.720528, 42.676361],
          [100.648944, 42.678444],
          [100.607333, 42.679639],
          [100.557472, 42.681028],
          [100.500389, 42.682583],
          [100.4065, 42.685111],
          [100.318111, 42.687389],
          [100.27844664700001, 42.650857286000019],
          [100.268528, 42.641722],
          [100.267593879, 42.639550230999987],
          [100.267417, 42.639139],
          [100.267424, 42.638861],
          [100.267429241, 42.63865798],
          [100.2675, 42.635917],
          [100.2675, 42.635889],
          [100.208861, 42.638444],
          [100.136444, 42.641445],
          [100.119894871999975, 42.642131233999976],
          [100.11896, 42.64217],
          [100.071528, 42.644139],
          [100.010528, 42.646639],
          [99.968194, 42.648361],
          [99.924556, 42.640778],
          [99.872861, 42.631722],
          [99.828556, 42.623945],
          [99.77275, 42.614139],
          [99.715389, 42.604028],
          [99.632361, 42.589333],
          [99.631883271999982, 42.58924840200001],
          [99.598497391000024, 42.665239333999978],
          [99.590803145999985, 42.755430221999973],
          [99.576395035000019, 42.915502548],
          [99.495107651000012, 43.235803604000012],
          [99.426031113000022, 44.118371964],
          [99.483407973999988, 44.124296188000017],
          [99.668058395, 44.142435074],
          [99.762071608999975, 44.163137436],
          [99.990762711, 44.059080124],
          [100.07532692, 43.989591599],
          [100.286153792999983, 43.829515457000014],
          [100.839250564999986, 43.845453261999978],
          [101.023702620999984, 43.850564957000017],
          [101.225267410000015, 43.853937148999989],
          [101.355287552, 43.902704239],
          [101.742216110000015, 44.041837692],
          [101.742315292, 44.041868210000018],
          [101.917901992999987, 44.095579147000024],
          [101.943433761999984, 44.106519698999989],
          [102.003923416000021, 44.128850936999982],
          [102.058774948, 44.143251419000023],
          [102.244211197000027, 44.158441544000027],
          [102.393522263000023, 44.183500289999984],
          [102.660619736, 44.166913986],
          [102.753973007000013, 44.167829514],
          [102.899610519000021, 44.175489426000013],
          [102.966028214, 44.17216301000002],
          [102.958410263000019, 44.204908370999988],
          [102.955575942999985, 44.214468002],
          [102.954557419000025, 44.217088698999987],
          [102.915327072000025, 44.247621536],
          [102.875463486, 44.282220839999979],
          [102.852304458999981, 44.310705185000018],
          [102.914613724, 44.389024733999975],
          [103.014436722000028, 44.435575485000015],
          [103.03387260400001, 44.506471633999979],
          [103.044378280999979, 44.545030594000025],
          [103.144536972000026, 44.700769423999986],
          [103.254220963000023, 44.836339951000014],
          [103.286172867, 44.863420486],
          [103.312078476000011, 44.875875473],
          [103.384752274, 44.907049179000012],
          [103.578569411999979, 44.985883713000021],
          [103.600889205999977, 45.007390976000011],
          [103.602499008, 45.008829117],
          [103.743333817, 45.134382248],
          [103.789834976, 45.17367363],
          [103.736059189, 45.286367416000019],
          [103.768888474, 45.311635970999987],
          [103.774446486999977, 45.315916061],
          [103.759840011999984, 45.365232467999988],
          [103.715391158999978, 45.371953964],
          [103.619844436999983, 45.439954758],
          [103.611246108999978, 45.517580032000012],
          [103.609426498, 45.57940101600002],
          [103.642946242999983, 45.652967452999974],
          [103.654241561999982, 45.680288314999984],
          [103.684877396, 45.698717117],
          [103.740449905, 45.732244492],
          [103.751401901, 45.738687514999981],
          [103.955026627, 45.716695786],
          [104.106817245, 45.73012352],
          [104.123548508, 45.865156174],
          [104.218683242999987, 45.962202072000025],
          [104.232458114999986, 45.99071312],
          [104.246553420999987, 46.032400130999974],
          [104.300977707000015, 46.124242783],
          [104.469133377, 46.125947952],
          [104.558946608999975, 46.137224197000023],
          [104.547739029000013, 46.192815780999979],
          [104.619459152, 46.238443374999974],
          [104.643781661999981, 46.251230239999984],
          [104.614934920999985, 46.312261580999973],
          [104.662900924999974, 46.385385513000017],
          [104.662984848, 46.385351180999976],
          [104.787153244000024, 46.474664688000018],
          [104.864641189999986, 46.533468245999984],
          [104.898839951000014, 46.568323135000014],
          [104.945714951000014, 46.584688186999983],
          [104.992212444000018, 46.587143858],
          [104.992216110000015, 46.587141036999981],
          [105.014925002999973, 46.577634811],
          [105.131635666000022, 46.557878494000022],
          [105.229181289999985, 46.530515670999989],
          [105.268610001000013, 46.508424758999979],
          [105.405450820999988, 46.461397170999987],
          [105.405584335000015, 46.46158409100002],
          [105.447851180999976, 46.521570205999978],
          [105.475294113000018, 46.538656235000019],
          [105.544404983999982, 46.605257033999976],
          [105.621023177999973, 46.669931411999983],
          [105.693975449, 46.735784530999979],
          [105.846418380999978, 46.741350174],
          [105.894350052, 46.697950363000018],
          [105.969244002999972, 46.671552658],
          [105.990167617999987, 46.654306411999983],
          [106.024888992, 46.637247086],
          [106.144594192999989, 46.614393233999976],
          [106.148435592999988, 46.562234879000016],
          [106.148496627999975, 46.561418533],
          [106.291582108, 46.59307289100002],
          [106.411710739, 46.591501236],
          [106.411725998, 46.591501236],
          [106.548154830999977, 46.593877792],
          [106.642587661999983, 46.595769882000013],
          [106.757394791000024, 46.585470199999975],
          [106.908216476, 46.536550522000027],
          [107.079710007000017, 46.415990829],
          [107.143144608, 46.406194686999982],
          [107.154321671, 46.403608322000025],
          [107.154489517, 46.40361976600002],
          [107.30277442900001, 46.415590286],
          [107.39974286, 46.423195831999976],
          [107.458574295, 46.418153763000021],
          [107.501405716000022, 46.455507278000027],
          [107.60971641499998, 46.55837822],
          [107.836023330999978, 46.558721542],
          [107.841554642, 46.679792404000011],
          [107.884290695, 46.780893326000012],
          [107.886629105, 46.780897141000025],
          [107.975671767999984, 46.781103133999977],
          [108.023561477999976, 46.815412520999985],
          [108.111860275000026, 46.821821213000021],
          [108.181016922000026, 46.828290939],
          [108.26159858699998, 46.824319839],
          [108.486753464, 46.792963027999974],
          [108.557142258, 46.792051314999981],
          [108.774320601999989, 46.87405204800001],
          [108.799711226999989, 46.898229599],
          [108.835683823000011, 46.935213089],
          [108.840524673, 46.99968147300001],
          [108.841760635000014, 46.998178482000014],
          [108.842805861999977, 46.99518013],
          [108.843660355, 46.994314194000026],
          [108.845273971999973, 46.993425369000022],
          [108.848878860000013, 46.992654800000025],
          [108.850751877, 46.992197036999983],
          [108.852258682000013, 46.991804123],
          [108.852640152, 46.990934372000027],
          [108.852491379000014, 46.989896773999988],
          [108.85270118699998, 46.989107132000015],
          [108.853456497000025, 46.988508223999986],
          [108.854642867999985, 46.988050461],
          [108.856119155999977, 46.987897873],
          [108.858789444000024, 46.98793602],
          [108.860128402999976, 46.987474442],
          [108.861387252999975, 46.986413955999978],
          [108.862424850000025, 46.985494614],
          [108.863996505999978, 46.985048294000023],
          [108.866250992, 46.985155105999979],
          [108.867738724, 46.985704422000026],
          [108.869535445999986, 46.987340927],
          [108.871454239, 46.988058089999981],
          [108.872995377, 46.988317489999986],
          [108.874422073, 46.987981795999985],
          [108.876314163000018, 46.986772536999979],
          [108.878511429000014, 46.985498428000028],
          [108.879556655999977, 46.984338760000014],
          [108.880395889, 46.982374191000019],
          [108.882131577, 46.980836867999983],
          [108.884054183999979, 46.979753494000022],
          [108.887426376, 46.979154586999982],
          [108.890405655, 46.979131699],
          [108.892759323, 46.979642867999985],
          [108.894395827999972, 46.981092452999974],
          [108.895299911, 46.981626511],
          [108.896821976000012, 46.981546402],
          [108.898187636999978, 46.980882645],
          [108.899038314999984, 46.980691910000019],
          [108.900178908999976, 46.980733870999984],
          [108.901468277, 46.980665207000015],
          [108.902845383, 46.979623795],
          [108.903230667, 46.978456497000025],
          [108.903615952, 46.977796555],
          [108.905958176000013, 46.975996017],
          [108.909200667999983, 46.974706649999973],
          [108.913179398000011, 46.973844527999972],
          [108.916818619000026, 46.972642899],
          [108.917905807000011, 46.971933364999984],
          [108.919179916000019, 46.97054863],
          [108.920682907000014, 46.968053817999987],
          [108.921899796, 46.967527389999987],
          [108.924680710000018, 46.966920852999976],
          [108.926984786999981, 46.966733932000011],
          [108.928346633999979, 46.967119217],
          [108.930078505999973, 46.968267441000023],
          [108.931768417, 46.969900130999974],
          [108.932638167999983, 46.970541],
          [108.93374443099998, 46.970640182000011],
          [108.935781479000013, 46.970594405999975],
          [108.937543869000024, 46.971071242999983],
          [108.939069748, 46.970994948999987],
          [108.939592361, 46.971189499],
          [108.940488814999981, 46.971643448],
          [108.942106247000027, 46.972284317],
          [108.943254470999989, 46.972406386999978],
          [108.944494247000023, 46.972177505],
          [108.94760703999998, 46.971288680999976],
          [108.948507308999979, 46.971258163000016],
          [108.949831008999979, 46.971643448],
          [108.950895308999975, 46.971685410000021],
          [108.954889297000022, 46.970525742],
          [108.957414627, 46.969633101999989],
          [108.958913802999973, 46.968530655],
          [108.951536179000016, 46.837614058999975],
          [109.060274123999989, 46.864839554000014],
          [109.10002327, 46.881441116000019],
          [109.12018013, 46.864191055],
          [109.098501205, 46.833551407000016],
          [109.07658577, 46.766214371],
          [109.059122086, 46.727735519000021],
          [109.041624069000022, 46.709569930999976],
          [109.04110527, 46.61438942],
          [109.051904678000028, 46.571905136],
          [109.043943405, 46.562837601000012],
          [109.019590377999975, 46.506719589],
          [109.054300308, 46.433431625000026],
          [109.164152145, 46.39670372],
          [109.189439774, 46.335256577],
          [109.151815414, 46.324674605999974],
          [109.328798294000023, 46.196821213000021],
          [109.352296829000011, 46.201372146999972],
          [109.400861739999982, 46.183755874999974],
          [109.471025467, 46.174406052],
          [109.549547195, 46.172979355],
          [109.693918227999973, 46.179025650000028],
          [109.874757767, 46.237077713000019],
          [109.933073044000025, 46.267416],
          [109.95788002, 46.279867172000024],
          [110.019575119000024, 46.355379105],
          [110.025194167999985, 46.436929702999976],
          [110.072240829, 46.495622635000018],
          [110.039880752999977, 46.51017952],
          [110.030298233, 46.630784988000016],
          [110.069936752, 46.633054733],
          [110.112905502, 46.623277664],
          [110.187273026000014, 46.61153602600001],
          [110.189195633, 46.605695723999986],
          [110.201932907000014, 46.566656113000022],
          [110.333097458, 46.443529129000012],
          [110.381948470999987, 46.417901992999987],
          [110.459688186999983, 46.371019363000016],
          [110.489904404000015, 46.296762466000018],
          [110.565092086999982, 46.22214698800002],
          [110.585920333999979, 46.195001602],
          [110.591924667, 46.134538651000014],
          [110.657747269000026, 46.091901779000011],
          [110.754693985000017, 46.078672408999978],
          [110.819505692, 46.067571639999983],
          [110.964826583999979, 46.059591292999983],
          [111.01418113699998, 46.090894698999989],
          [111.040964127, 46.113233566000019],
          [111.121644974, 46.15285301199998],
          [111.23174476600002, 46.235795974999974],
          [111.295743942, 46.218095779],
          [111.34164238, 46.207464217999984],
          [111.391572952, 46.186281204000011],
          [111.455686569000022, 46.160066605],
          [111.534086226999989, 46.12452507],
          [111.577444077, 46.109956741000019],
          [111.641195297000024, 46.093702316000019],
          [111.668138504000012, 46.041490555],
          [111.68897438, 46.000738144000024],
          [111.744588852, 45.924749373999987],
          [111.752298355, 45.908884048],
          [111.760087967, 45.857782364],
          [111.778474808, 45.825239182000018],
          [111.788183211999979, 45.79747963],
          [111.754304886, 45.634897232000014],
          [111.751844405999975, 45.621282577999978],
          [111.745435714999985, 45.58410453800002],
          [111.731554030999973, 45.518976211999984],
          [111.773199080999973, 45.504304886],
          [111.855314255, 45.452619552999977],
          [111.844522476, 45.390611649],
          [111.935876845999985, 45.319189071999972],
          [111.98674202, 45.272195816000021],
          [111.963354111, 45.215017319000026],
          [111.971371369, 45.083747062999976],
          [111.971056, 45.083667],
          [111.964760022, 45.079640352000013],
          [111.964256, 45.079318],
          [111.951861, 45.071389],
          [111.943772312000021, 45.068168456000024],
          [111.915674, 45.056981],
          [111.904454505, 45.052513525999984],
          [111.903971, 45.052321],
          [111.882583, 45.043806],
          [111.871655, 45.038145],
          [111.871, 45.037806],
          [111.868333, 45.036222],
          [111.860682774999987, 45.031689729],
          [111.837528, 45.017972],
          [111.816286794, 45.008005034],
          [111.808167, 45.004195],
          [111.800361, 44.999861],
          [111.790001, 44.993317],
          [111.787079, 44.991471],
          [111.779167, 44.986472],
          [111.774609828, 44.983488448],
          [111.766778, 44.978361],
          [111.762236114000018, 44.972749538000016],
          [111.759334, 44.969164],
          [111.753917, 44.962472],
          [111.750861, 44.958445],
          [111.746768036, 44.953969055000016],
          [111.745806, 44.952917],
          [111.742752, 44.949565],
          [111.735278, 44.941361],
          [111.734336997000014, 44.939841279],
          [111.731434497, 44.935153733999982],
          [111.728639, 44.930639],
          [111.708917, 44.898583],
          [111.701417, 44.887278],
          [111.698147, 44.879824],
          [111.694667, 44.871889],
          [111.69175, 44.869139],
          [111.686194, 44.86375],
          [111.683326447000013, 44.86046802200002],
          [111.675469, 44.851475],
          [111.674310714, 44.850148466],
          [111.674278, 44.850111],
          [111.67162, 44.846663],
          [111.668819446999976, 44.84302928],
          [111.665778, 44.839083],
          [111.659472, 44.829833],
          [111.646222, 44.810139],
          [111.645301, 44.809493],
          [111.644628749, 44.809021703999974],
          [111.643528, 44.80825],
          [111.641373709, 44.803967409],
          [111.641373, 44.803966],
          [111.641167, 44.803556],
          [111.639446535, 44.801519234000011],
          [111.634667, 44.795861],
          [111.632235240999989, 44.793048789000011],
          [111.618694, 44.777389],
          [111.599778, 44.743195],
          [111.600156, 44.741144],
          [111.600833, 44.737472],
          [111.596601, 44.734638],
          [111.594694, 44.733361],
          [111.57775, 44.704167],
          [111.574416, 44.694374],
          [111.574194, 44.693722],
          [111.573697659, 44.692694914000015],
          [111.570443, 44.68596],
          [111.567256666999981, 44.679366105999975],
          [111.566583, 44.677972],
          [111.566221031999987, 44.674477448],
          [111.566178, 44.674062],
          [111.565694, 44.669389],
          [111.558983, 44.653401],
          [111.555083, 44.644111],
          [111.555861, 44.638278],
          [111.559203, 44.612836],
          [111.561833, 44.592806],
          [111.562833, 44.574778],
          [111.55575, 44.565195],
          [111.537252, 44.555518],
          [111.526333, 44.549806],
          [111.518641, 44.530934],
          [111.509361, 44.508167],
          [111.500384704, 44.506010851999974],
          [111.500173, 44.50596],
          [111.499417, 44.505778],
          [111.488688600999978, 44.497371322999982],
          [111.476155084000027, 44.487550172999988],
          [111.475028, 44.486667],
          [111.459778, 44.4595],
          [111.445111, 44.433333],
          [111.423194, 44.394167],
          [111.421167, 44.381056],
          [111.411333, 44.355833],
          [111.42075, 44.328917],
          [111.424056, 44.3195],
          [111.451639, 44.310945],
          [111.473774, 44.305744],
          [111.481667, 44.303889],
          [111.483775, 44.302924],
          [111.488721, 44.30066],
          [111.49775, 44.296528],
          [111.500893989000019, 44.293457188],
          [111.503722, 44.290695],
          [111.510472, 44.285361],
          [111.513389, 44.28075],
          [111.518806, 44.272278],
          [111.524611, 44.268306],
          [111.52775, 44.263278],
          [111.525017, 44.254699],
          [111.524076700000023, 44.251749279000023],
          [111.523944, 44.251333],
          [111.523756, 44.251238],
          [111.523683, 44.251047],
          [111.523756, 44.250841],
          [111.523932, 44.250636],
          [111.524064532000011, 44.25048711300002],
          [111.524167, 44.250372],
          [111.524358, 44.250093],
          [111.524402, 44.249902],
          [111.524387, 44.249711],
          [111.524285, 44.249623],
          [111.524167, 44.249638],
          [111.524056756999983, 44.249680593999983],
          [111.523903, 44.24974],
          [111.523653, 44.249755],
          [111.523272, 44.249594],
          [111.523125, 44.249461],
          [111.523066, 44.2493],
          [111.523095, 44.249138],
          [111.523184, 44.248904],
          [111.523169, 44.248654],
          [111.523051, 44.248375],
          [111.523051, 44.248214],
          [111.52311, 44.248052],
          [111.523316, 44.247788],
          [111.523521, 44.247436],
          [111.523668, 44.247039],
          [111.523773339, 44.246797508999975],
          [111.523815, 44.246702],
          [111.52402, 44.246335],
          [111.524299, 44.24607],
          [111.524549, 44.245718],
          [111.524813, 44.245263],
          [111.524901, 44.244984],
          [111.524872, 44.244778],
          [111.524784, 44.244661],
          [111.524549, 44.244485],
          [111.52427, 44.244338],
          [111.523903, 44.244206],
          [111.523477, 44.244118],
          [111.523258533999979, 44.244061343],
          [111.523022, 44.244],
          [111.522787, 44.243839],
          [111.522582, 44.243575],
          [111.52242, 44.243193],
          [111.5222, 44.242532],
          [111.522127, 44.242092],
          [111.522171, 44.241916],
          [111.522273, 44.241813],
          [111.522494, 44.24171],
          [111.522978, 44.241637],
          [111.523551, 44.241519],
          [111.524461, 44.241329],
          [111.524876109, 44.241139213],
          [111.524975, 44.241094],
          [111.525297, 44.240815],
          [111.525635, 44.240389],
          [111.525811, 44.240022],
          [111.526017, 44.239684],
          [111.526501, 44.239273],
          [111.526854, 44.238965],
          [111.527103, 44.238583],
          [111.527411, 44.237996],
          [111.527749, 44.237585],
          [111.52794, 44.237306],
          [111.528047921999985, 44.236995148],
          [111.528057, 44.236969],
          [111.528204, 44.236675],
          [111.528336, 44.236469],
          [111.528615, 44.236249],
          [111.52889, 44.236174],
          [111.528938, 44.236161],
          [111.529217545999984, 44.236106670000026],
          [111.52954, 44.236044],
          [111.530098, 44.235941],
          [111.530362, 44.23575],
          [111.530626, 44.2355],
          [111.530905, 44.235104],
          [111.531130067, 44.234653865999974],
          [111.53114, 44.234634],
          [111.531405, 44.233988],
          [111.531537, 44.233489],
          [111.53161, 44.232785],
          [111.531713, 44.232315],
          [111.531904, 44.231742],
          [111.532388, 44.230715],
          [111.532388, 44.230465],
          [111.532241, 44.230201],
          [111.532094, 44.229672],
          [111.532183, 44.227324],
          [111.532212, 44.226986],
          [111.532306, 44.226778],
          [111.532606193, 44.223687047],
          [111.533031, 44.219313],
          [111.533861, 44.210778],
          [111.544022693999977, 44.190691273000027],
          [111.547, 44.184806],
          [111.55775, 44.166639],
          [111.565861, 44.159806],
          [111.569111, 44.154056],
          [111.577244753, 44.147167102000026],
          [111.586299958999973, 44.13949777800002],
          [111.587713, 44.138301],
          [111.591611, 44.135],
          [111.595176, 44.127015],
          [111.599944, 44.116333],
          [111.603331866000019, 44.113001114999975],
          [111.606722, 44.109667],
          [111.609264554999982, 44.107263626000019],
          [111.609517, 44.107025],
          [111.61538684300001, 44.101475529000027],
          [111.624028, 44.093306],
          [111.655056, 44.062972],
          [111.663722, 44.056472],
          [111.670055, 44.050878],
          [111.678672447999986, 44.043264651000015],
          [111.679444, 44.042583],
          [111.684936, 44.039807],
          [111.685783, 44.039379],
          [111.687995351999973, 44.038260504],
          [111.696917, 44.03375],
          [111.705079263000016, 44.030733145],
          [111.706611, 44.030167],
          [111.722917, 44.022611],
          [111.740639, 44.013],
          [111.742116771999974, 44.012617062],
          [111.752198519, 44.010004558999981],
          [111.772368, 44.004778],
          [111.775583, 44.003945],
          [111.776411, 44.003351],
          [111.816778, 43.974417],
          [111.825944, 43.967833],
          [111.863153, 43.941127],
          [111.864360922, 43.940259938999986],
          [111.867083, 43.938306],
          [111.869782, 43.934341],
          [111.869808852, 43.934301545999972],
          [111.892342234000012, 43.901193627],
          [111.893512821, 43.899473702000023],
          [111.896917, 43.894472],
          [111.914611, 43.872778],
          [111.938306, 43.843667],
          [111.940238, 43.840984],
          [111.95475, 43.820833],
          [111.956555, 43.813926],
          [111.958467, 43.806607],
          [111.960389, 43.79925],
          [111.961406, 43.786233],
          [111.964694, 43.744167],
          [111.950317, 43.701455],
          [111.946667, 43.690611],
          [111.946574528999975, 43.690541855],
          [111.946556, 43.690528],
          [111.946583, 43.690361],
          [111.946444, 43.690278],
          [111.934377701000017, 43.688799194000012],
          [111.922194, 43.687306],
          [111.921087966000016, 43.68690038],
          [111.918501734000017, 43.685951923],
          [111.91418, 43.684367],
          [111.911416, 43.683354],
          [111.906361, 43.6815],
          [111.886844183999983, 43.674163255],
          [111.884194, 43.673167],
          [111.884055498, 43.673161970000024],
          [111.874089, 43.6728],
          [111.835167, 43.671389],
          [111.787444, 43.669639],
          [111.787005, 43.669266],
          [111.78700206100001, 43.669263506999982],
          [111.77274773, 43.657171619999986],
          [111.76427, 43.64998],
          [111.743861, 43.632667],
          [111.703139, 43.598028],
          [111.693076, 43.589483],
          [111.688201855999978, 43.585343694000017],
          [111.661397, 43.56258],
          [111.661353, 43.562543],
          [111.661139, 43.562361],
          [111.657477089, 43.559251737000011],
          [111.640333, 43.544695],
          [111.639127519999988, 43.543671694000011],
          [111.631070582, 43.536832335999975],
          [111.628389, 43.534556],
          [111.608345359, 43.517489727],
          [111.603830316000028, 43.513645368000027],
          [111.599778, 43.510195],
          [111.566787687999977, 43.492445915000019],
          [111.55935681699998, 43.48844803999998],
          [111.558472, 43.487972],
          [111.529275658000017, 43.48720984800002],
          [111.502083, 43.4865],
          [111.49342208600001, 43.48731367900001],
          [111.485391617, 43.488332748],
          [111.493422, 43.487313],
          [111.489797, 43.487653],
          [111.452189718999989, 43.491180752],
          [111.45175, 43.491222],
          [111.440696, 43.487419],
          [111.4387109, 43.486735984],
          [111.393139, 43.471056],
          [111.362784, 43.444259],
          [111.356889, 43.439056],
          [111.348722, 43.434917],
          [111.336056, 43.431167],
          [111.332253, 43.430742],
          [111.318417, 43.429195],
          [111.294972, 43.423972],
          [111.260083, 43.416167],
          [111.2255, 43.405083],
          [111.171806, 43.390611],
          [111.146972, 43.376861],
          [111.086972, 43.361445],
          [111.062306, 43.355083],
          [111.057139, 43.348222],
          [111.049639, 43.342889],
          [111.040094, 43.33798],
          [111.039917, 43.337889],
          [111.038929, 43.337474],
          [111.03171499299998, 43.334443224999973],
          [111.024815784, 43.331544704],
          [111.021139, 43.33],
          [111.002694, 43.318528],
          [110.993806, 43.313361],
          [110.962583, 43.286056],
          [110.96252825, 43.286004182999989],
          [110.962527, 43.286003],
          [110.958090836, 43.281824374999985],
          [110.956791, 43.2806],
          [110.906722, 43.233445],
          [110.876417, 43.204833],
          [110.837028, 43.167528],
          [110.806917, 43.139],
          [110.765556, 43.099722],
          [110.740194982999981, 43.089708019],
          [110.739111, 43.08928],
          [110.72975, 43.085583],
          [110.705279510000025, 43.061074889],
          [110.704383, 43.060177],
          [110.693861, 43.049639],
          [110.684659, 43.040417],
          [110.681395898, 43.037146113],
          [110.681306, 43.037056],
          [110.681769, 43.029614],
          [110.682508353, 43.017732724999973],
          [110.682528, 43.017417],
          [110.673185235, 43.004116926],
          [110.671191725000028, 43.00127902600002],
          [110.653083, 42.9755],
          [110.623667, 42.933556],
          [110.567056, 42.898361],
          [110.516972, 42.867167],
          [110.465584, 42.835094],
          [110.465455209000027, 42.835013586],
          [110.464584769999988, 42.83447010499998],
          [110.464583, 42.834469],
          [110.4645, 42.834417],
          [110.462914475, 42.831638499],
          [110.462432, 42.830793],
          [110.433333, 42.779806],
          [110.41107991299998, 42.769854134000013],
          [110.399338, 42.764603],
          [110.387306, 42.759222],
          [110.332778, 42.734806],
          [110.303694, 42.725583],
          [110.246509060999983, 42.707453793000013],
          [110.24649883799998, 42.707450778],
          [110.236667, 42.704333],
          [110.189361, 42.689306],
          [110.155995, 42.678679],
          [110.132583, 42.671222],
          [110.128714, 42.667399],
          [110.102278, 42.641278],
          [110.079870079999978, 42.640447279],
          [110.078352, 42.640391],
          [110.053556, 42.639472],
          [110.004833, 42.637611],
          [109.979889, 42.636472],
          [109.898167, 42.632667],
          [109.865639, 42.621695],
          [109.829361, 42.609445],
          [109.816906207999978, 42.605234610000025],
          [109.816721, 42.605172],
          [109.748167, 42.582],
          [109.6795, 42.558667],
          [109.619778, 42.522222],
          [109.577417, 42.496306],
          [109.556278, 42.483389],
          [109.535167, 42.470445],
          [109.530149, 42.470018],
          [109.496639, 42.467167],
          [109.489631, 42.462707],
          [109.478917, 42.455889],
          [109.440778, 42.452445],
          [109.406917, 42.449389],
          [109.373056, 42.446306],
          [109.350639, 42.444278],
          [109.314692, 42.441008],
          [109.30575, 42.440195],
          [109.303441, 42.439641],
          [109.284417, 42.435083],
          [109.258361, 42.437306],
          [109.223528, 42.44025],
          [109.190444, 42.443056],
          [109.145472, 42.446833],
          [109.104083, 42.450306],
          [109.074, 42.452806],
          [109.04395, 42.455296],
          [109.018028, 42.457445],
          [109.013134, 42.453912],
          [109.00275, 42.446417],
          [108.996332, 42.451028],
          [108.994361, 42.452445],
          [108.976077712, 42.446930377],
          [108.942972, 42.436945],
          [108.899389, 42.420083],
          [108.884497, 42.414298],
          [108.839972, 42.397],
          [108.830722, 42.40475],
          [108.805054, 42.411434],
          [108.787944, 42.415889],
          [108.748972, 42.415361],
          [108.698, 42.414639],
          [108.631361, 42.426417],
          [108.537306, 42.442972],
          [108.535465859999988, 42.442989093999984],
          [108.52934, 42.443046],
          [108.447167, 42.443806],
          [108.406056, 42.441278],
          [108.360944, 42.43925],
          [108.294889, 42.439],
          [108.244917, 42.463278],
          [108.1885, 42.452222],
          [108.134694, 42.4445],
          [108.083917, 42.437194],
          [108.019333, 42.434167],
          [108.019160981000027, 42.434082018000026],
          [107.977556, 42.413528],
        ],
      ],
    ],
  },
};
